import { render } from "./ForgetPasswordPage.vue?vue&type=template&id=54659e6a&scoped=true"
import script from "./ForgetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordPage.vue?vue&type=script&lang=js"

import "./ForgetPasswordPage.vue?vue&type=style&index=0&id=54659e6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54659e6a"]])

export default __exports__